export default __webpack_public_path__ + "static/media/16.18.b3e5e5a1.png";